<template>
  <div v-if="competition">
    <b-link :to="{name: 'admin.competition', params:{id: competition.id}}">zurück zur Übersicht</b-link>
    <h3 class="mb-3">Fragenkatalog {{ competition.title() }}</h3>
      <b-tabs card @input="setAgeGroup" ref="tab">

        <!-- Categories -->
        <b-tab title="Kategorien" :key="'categories'">
          <!-- EXISTING -->
          <b-form-group v-for="(category, index) in categories" :key="category.value" :label="'Kategorie ' + (index + 1)" horizontal>
            <b-form-input v-model="category.text"></b-form-input>
          </b-form-group>

          <!-- NEW -->
          <b-form v-if="categories.length < 3">
            <b-form-group :label="'Kategorie ' + (categories.length + 1)" horizontal>
              <b-form-input v-model="newCategory"></b-form-input>
            </b-form-group>
            <b-button v-on:click="saveNewCategory" class="float-right">
              Speichern
            </b-button>
          </b-form>
        </b-tab>


        <!-- Questions -->
        <b-tab v-for="(item) in ageGroups" :title="item.title" :key="item.id">

          <b-form v-on:submit.prevent="send(item.id)" autocomplete="off" class="clearfix">
            <b-form-group label-for="category" label="Kategorie:" horizontal>
              <b-form-select
                    :id="'category' + item.id"
                    :ref="'category' + item.id"
                    :options="categories"
                    v-model="item.categoryId"
                    v-on:change="refreshQuestionsTbl"
                    required
              />
            </b-form-group>

            <b-form-group label-for="position" label="Nächste Position:" horizontal>
              <b-form-input name="position" v-model="questions.length + 1" disabled/>
            </b-form-group>

            <b-form-group label-for="question" label="Frage:" horizontal>
              <b-form-textarea :rows=2 name="question" v-model="item.question.question" autocomplete="off" required/>
            </b-form-group>

            <b-form-group label-for="img" label="Bild:" horizontal>
              <question-img :question=item.question></question-img>
            </b-form-group>

            <b-form-group label-for="answer-a" label="Antwort A:" horizontal>
              <b-form-input name="answer-a" v-model="item.question.answers.a" autocomplete="off" required/>
            </b-form-group>

            <b-form-group label-for="answer-b" label="Antwort B:" horizontal>
              <b-form-input name="answer-b" v-model="item.question.answers.b" autocomplete="off" required/>
            </b-form-group>

            <b-form-group label-for="answer-c" label="Antwort C:" horizontal>
              <b-form-input name="answer-c" v-model="item.question.answers.c" autocomplete="off" required/>
            </b-form-group>

            <b-form-group label-for="correct-answer" label="Richtige Antwort:" horizontal>
              <b-form-select name="correct-answer" v-model="item.question.correct" :options="answerOptions" autocomplete="off" required/>
            </b-form-group>

            <b-button v-if="item.question.id" type="button" v-on:click="resetForm(item)" variant="secondary" class="float-left">
              abbrechen
            </b-button>

            <b-button type="submit" :disabled="!item.question.question" variant="primary" class="float-right">
              speichern
            </b-button>
          </b-form>
        </b-tab>
      </b-tabs>

      <question-table
            v-if="questions && currentTab() > 0"
            v-bind:questions="questions"
            v-on:deleteQuestion="deleteQuestion"
            v-on:editQuestion="editQuestion"
            v-on:reload="loadQuestions"
            class="mt-5"></question-table>
  </div>
</template>
<script>
import {Competition} from '@/models'
import QuestionTable from '@/components/competitions/admin/QuestionsTable'
import QuestionImg from '@/components/competitions/admin/QuestionImg'

const ages = [3, 5, 7]
const answerOptions = ['A', 'B', 'C']

export default {
  name: 'questions',
  components: {
    QuestionTable: QuestionTable,
    QuestionImg: QuestionImg
  },
  data: function () {
    let competition = new Competition({
      id: this.$route.params.id
    })

    let ageGroups = {}
    ages.forEach((age) => {
      ageGroups[age] = {
        id: age,
        title: age + './' + (age + 1) + '. Klasse',
        categoryId: null,
        question: {
          id: null,
          question: '',
          answers: {
            a: '',
            b: '',
            c: ''
          },
          correct: ''
        },
        questions: {}
      }
    })

    return {
      loaded: false,
      competition: competition,
      ageGroup: 3,
      ageGroups: ageGroups,
      answerOptions: answerOptions,
      newCategory: '',
      categories: [],
      questions: [] // for table
    }
  },

  mounted: function () {
    this.competition.fetch().then(this.loadCategories)
  },

  methods: {
    currentTab: function () {
      if (!this.$refs.tab) {
        return 0
      }

      return this.$refs.tab.currentTab
    },

    saveNewCategory: function () {
      let body = JSON.stringify({
        name: this.newCategory
      })

      this.axios.post('/competitions/' + this.competition.id + '/categories', body)
        .then((rsp) => {
          this.categories.push({
            value: rsp.data.id,
            text: rsp.data.name
          })

          this.newCategory = ''
        })
    },

    loadCategories: function () {
      this.axios.get('/competitions/' + this.competition.id + '/categories')
        .then((rsp) => {
          rsp.data.forEach((item) => {
            this.categories.push({
              value: item.id,
              text: item.name
            })

            // preselect first category if available
            if (rsp.data[0]) {
              for (let age in this.ageGroups) {
                this.ageGroups[age].categoryId = rsp.data[0].id
              }
            }
          })
        })

        .then(this.loadQuestions)
    },

    setAgeGroup: function (index) {
      if (index < 1) {
        return
      }

      let ag = ages[index - 1]
      this.ageGroup = ag
      this.refreshQuestionsTbl(this.ageGroups[ag].categoryId)
    },

    refreshQuestionsTbl: function (catId) {
      this.$set(this, 'questions', [])

      let ag = this.ageGroups[this.ageGroup]

      if (!catId) {
        catId = ag.categoryId
      }

      if (!ag.questions[catId]) {
        return
      }

      ag.questions[catId].forEach((q) => {
        this.questions.push(q)
      })
    },

    loadQuestions: function () {
      this.questions = []

      for (let age in this.ageGroups) {
        this.ageGroups[age].questions = {}
      }

      this.axios.get('/competitions/' + this.competition.id + '/questions')
        .then((rsp) => {
          rsp.data.forEach((q) => {
            this.addQuestion(q)
          })

          this.refreshQuestionsTbl()
        })
    },

    addQuestion: function (q) {
      let age = q.ageGroup
      let cat = q.categoryId
      let group = this.ageGroups[age]

      if (!group.questions[cat]) {
        group.questions[cat] = []
      }

      group.questions[cat].push({
        id: q.id,
        position: q.position,
        question: q.question,
        image: q.image,
        imagePath: q.imagePath,
        answers: q.answers,
        correct: q.correct
      })
    },

    editQuestion: function (id) {
      let group = this.ageGroups[this.ageGroup]
      let question = this.findQuestion(this.ageGroup, id)

      if (question !== null) {
        group.question = question
      }
    },

    findQuestion: function (age, id) {
      let group = this.ageGroups[age]
      for (let catId in group.questions) {
        for (let idx in group.questions[catId]) {
          let question = group.questions[catId][idx]
          if (question.id === id) {
            return question
          }
        }
      }
    },

    deleteQuestion: function (id) {
      this.axios.delete('/questions/' + id).then(this.loadQuestions)
    },

    send: function (e) {
      let ageGroup = this.ageGroups[e]

      if (ageGroup.question.id) {
        this.update(ageGroup)
          .then(() => {
            this.resetForm(ageGroup)
            this.loadQuestions()
          })
      } else {
        this.insert(ageGroup)
          .then(() => {
            this.resetForm(ageGroup)
            this.loadQuestions()
          })
          .catch((err) => {
            this.$eventHub.$emit('error', err)
          })
      }
    },

    insert: function (ageGroup) {
      let question = ageGroup.question
      let position = 1

      if (ageGroup.questions[ageGroup.categoryId]) {
        position = ageGroup.questions[ageGroup.categoryId].length + 1
      }

      let str = {
        ageGroup: ageGroup.id,
        categoryId: ageGroup.categoryId,
        position: position,
        question: question.question,
        image: question.image,
        answers: question.answers,
        correct: question.correct
      }

      let clone = JSON.parse(JSON.stringify(str))

      return this.axios.post('/competitions/' + this.competition.id + '/questions', JSON.stringify(clone))
        .then(() => {
          // prepare display
          clone._showDetails = false

          // push to list
          this.addQuestion(clone)
        })
    },

    update: function (ageGroup) {
      let question = ageGroup.question

      let body = {
        question: question.question,
        answers: question.answers,
        correct: question.correct
      }

      return this.axios.patch('/questions/' + question.id, JSON.stringify(body))

        .then((rsp) => {
          // push to list
          this.addQuestion(JSON.parse(JSON.stringify({
            id: rsp.data.id,
            categoryId: rsp.data.categoryId,
            question: rsp.data.question,
            answers: rsp.data.answers,
            correct: rsp.data.correct,
            _showDetails: false
          })))
        })
    },

    resetForm: function (ageGroup) {
      let question = ageGroup.question

      question.id = null
      question.question = ''
      question.image = ''
      question.answers.a = ''
      question.answers.b = ''
      question.answers.c = ''
      question.correct = ''
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/admin/competitions/Questions.vue